import get from 'lodash/get';
import Multiselect from 'vue-multiselect';

import { i18n } from '../../translation';
import './QdMultiSelect.scss';
import template from './QdMultiSelect.vhtml';

//import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
	name: 'QdMultiSelect',
	template: template,
	components: {
		Multiselect,
	},
	props: {
		options: {
			type: Array,
			required: true,
		},
		defaultValues: {
			type: (Object, Array),
			default: null,
		},
		placeholder: {
			type: String,
			default: i18n.tc('choose'),
		},
		bigText: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		searchable: {
			type: Boolean,
			default: true,
		},
		trackBy: {
			type: String,
			default: 'title',
		},
        name: {
		    type: String,
            default: null
        }
	},
	data: () => ({
		value: null,
	}),
	computed: {
		selectionsLabel: vm => {
			let str = '';
			if (vm.multiple && vm.value != null) {
				vm.value.forEach((item, index) => {
					str += vm.value.length !== index + 1 ? `${item.label}, ` : item.label;
				});
			} else {
				str = get(vm.value, 'label', '');
			}
			return str;
		},
		multiSelectClasses: vm => {
			let dynamicClasses = {
				'multiselect--big': vm.bigText,
			};

			return [dynamicClasses];
		},
	},
	watch: {
		value() {
			if ( this.trackBy !== '') {
				const value = this.value.map(item => item[this.trackBy]);
				this.$emit('qd-multi-select-selection', value);
			} else {
				this.$emit('qd-multi-select-selection', this.value);
			}
		},
	},
	methods: {},
	beforeMount() {
		if (this.defaultValues !== null) {
			const chosenObjects = this.options.filter(option => this.defaultValues.includes(option[this.trackBy].toString()));
			this.value = chosenObjects;
		}
	}
};
